import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { actions } from '../actions/confirmModal';
import { ConfirmModal } from '../components/confirmModal';
import { ConfirmModalState } from '../reducers/confirmModal';

const mapStateToProps = (state: ConfirmModalState) => {
  const { isShown, headline, text, cancelText, confirmText } =
    state.confirmModal;
  return {
    isShown,
    headline,
    text,
    cancelText,
    confirmText,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    cancel: () => dispatch(actions.confirmModalCancel()),
    confirm: () => dispatch(actions.confirmModalConfirm()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmModal);
